import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { logo } from "../Common/CommonImages";

export default function AssessmentHeader({ activeStep, hasSystemCheck = false }) {
  const hasPromoVideo = useSelector((state) => state.testReducer.hasPromoVideo);
  
  // Conditionally include 'About Company'
  const baseSteps = hasPromoVideo !== false 
    ? ["About Company", "Summary", "Enter Details", "Start Test"]
    : ["Summary", "Enter Details", "Start Test"];
    
  const systemSteps = hasPromoVideo !== false
    ? ["About Company", "Summary", "Enter Details", "System Check", "Start Test"]
    : ["Summary", "Enter Details", "System Check", "Start Test"];

  const steps = hasSystemCheck ? systemSteps : baseSteps;
  
  const activeIndex = steps.indexOf(activeStep);

  return (
    <Box sx={{ 
      bgcolor: "#fff", 
      borderBottom: "1px solid #eee", 
      boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: { base: 1, sm: 2 },
      py: 0.5,
      minHeight: "56px"
    }}>
      {/* <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
        <img src={logo} alt="HireCorrecto" style={{ height: 38 }} />
      </Box> */}
      {/* <Box sx={{ flex: 2, display: "flex", justifyContent: "center", width: "100%" }}> */}
        <Box sx={{ px: { base: 2, sm: 4 }, py: 0.5, width: "100%" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={0}
            sx={{ maxWidth: 700, mx: "auto", width: "100%" }}
          >
            {steps.map((step, i) => {
              const isActive = i === activeIndex;
              const isPast = i < activeIndex && activeIndex !== -1;

              return (
                <React.Fragment key={step}>
                  <Stack alignItems="center" spacing={0.5} sx={{ minWidth: 80 }}>
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        bgcolor: isActive ? "#FF6812" : isPast ? "#4caf50" : "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: isActive ? "0 0 0 4px rgba(255,104,18,0.15)" : "none",
                        transition: "all 0.3s",
                      }}
                    >
                      {isPast ? (
                        <CheckCircleOutline sx={{ fontSize: 16, color: "#fff" }} />
                      ) : isActive ? (
                        <Typography sx={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>{i + 1}</Typography>
                      ) : (
                        <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: "#bdbdbd" }} />
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "11px",
                        fontWeight: isActive ? 700 : 400,
                        color: isActive ? "#FF6812" : "#9e9e9e",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {step}
                    </Typography>
                  </Stack>
                  {i < steps.length - 1 && (
                    <Box sx={{ flex: 1, height: "2px", bgcolor: "#e0e0e0", mt: "-14px" }} />
                  )}
                </React.Fragment>
              );
            })}
          </Stack>
        </Box>
      {/* </Box> */}
      <Box sx={{ flex: 1 }} />
    </Box>
  );
}
